import React, { useRef, useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { SignatureCanvas } from "../SignaturePad/SignatureCanvas";

const SignatureFieldBase64 = ({ value, onChange, label = "Signature" }) => {
  const signatureRef = useRef();
  const [blobURL, setBlobURL] = useState(null);

  const dataURLtoBlob = (dataurl) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new Blob([u8arr], { type: mime });
  };

  const handleEndDrawing = () => {
    const dataURL = signatureRef.current.getSignature();
    if (dataURL) {
      const blob = dataURLtoBlob(dataURL);
      onChange(blob);
    } else {
      onChange(null);
    }
  };

  const handleClear = () => {
    if (signatureRef.current) signatureRef.current.clear();
    onChange(null);
    setBlobURL(null);
  };

  useEffect(() => {
    let url;
    if (value && signatureRef.current) {
      if (value instanceof Blob) {
        url = URL.createObjectURL(value);
        signatureRef.current.loadImage(url);
        setBlobURL(url);
      } else {
        signatureRef.current.loadImage(value); // base64 string
      }
    }
    return () => {
      if (url) URL.revokeObjectURL(url);
    };
  }, [value]);

  return (
    <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start", mt: 1 }}>
      <Box sx={{ flex: 1 }}>
        <SignatureCanvas ref={signatureRef} onEndDrawing={handleEndDrawing} />
      </Box>

      <Button
        variant="outlined"
        color="secondary"
        onClick={handleClear}
        sx={{ height: "fit-content", mt: 4 }}
      >
        Clear
      </Button>
    </Box>
  );
};

export default SignatureFieldBase64;